module.exports = __webpack_public_path__ + "static/10-af435b9c4411221cfb8f8beea39cd0b9.jpg";